/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit, TemplateRef, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { timer } from 'rxjs';
import { AuthAmplifyService } from 'src/app/shared/service/auth-amplify.service';
import { TranslationService } from 'src/app/shared/service/translation.service';
import { CommonModalComponent } from "src/app/shared/common-modal/common-modal.component";

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, CommonModalComponent]
})
export class AccessDeniedComponent implements OnInit {

  private readonly authAmplifyService = inject(AuthAmplifyService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly translationService = inject(TranslationService);
  private readonly _destroyRef = inject(DestroyRef);

  type: string = 'medium-popup';
  showModal: boolean = true
  userName: any
  timer: number = 30
  translationData: any
  @ViewChild("showModalContent") showModalContent: TemplateRef<any> | undefined;

  ngOnInit(): void {
    this.userName = localStorage.getItem('userName')
    this.setTimer()
  }

  setTimer() {
    timer(0, 1000)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => {
        this.timer--;
        this.cdr.markForCheck();
        if (this.timer == 0) {
          this.authAmplifyService.logout();
        }
      });
  }



}
